<template>
  <div class="sex_chart_box">
    <div class="woman_box">
      <div class="woman">
        <div class="percent">{{perwoman}}</div>
        <div class="sex" v-if="MeetingStat.data.length>0">{{MeetingStat.data[1].name}}</div>
        <div class="num" v-if="MeetingStat.data.length>0">{{MeetingStat.data[1].value}}人</div>
      </div>
    </div>
    <div class="man_box">
      <div class="man">
        <div class="percent">{{perman}}</div>
        <div class="sex" v-if="MeetingStat.data.length>0">{{MeetingStat.data[0].name}}</div>
        <div class="num" v-if="MeetingStat.data.length>0">{{MeetingStat.data[0].value}}人</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    MeetingStat: {
      type: Object,
      default: {
        data:[
            {
              name:"男",
              value:0
            },
            {
              name:"女",
              value:0
            }
          ]
      },
    },
  },
  watch: {
    "MeetingStat": function (val) {
      this.getPercent(val)
    },
  },
  data(){
    return{
      perman:null,
      perwoman:null,
    }
  },
  methods:{
    getPercent(val){
      val = val.data
      const total = val[0].value + val[1].value
      // 男
      //let perman = Math.floor(val[0].value / total*100)+"%"
      const perman = total===0?"0%":Math.floor(val[0].value / total*100)+"%"
      // 女
      const perwoman = total===0?"0%":Math.floor((1-val[0].value / total)*100)+"%"
      this.perman = perman
      this.perwoman = perwoman
      // console.log(perman,perwoman)
      
    }
  }
}
</script>
<style lang="less" scoped>
.sex_chart_box{
  width: 100%;
  height: 100%;
  background: url(../../assets/images/toatl_nanv.png) no-repeat center bottom;
  background-size:contain;
  position: relative;
  .woman_box,.man_box{
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: absolute;
  }
  .woman{
    left:calc(1 / 19.2 * 18vw);
    background: url(../../assets/images/yellowcircle.png) no-repeat center center;
  }
  .man{
    right:calc(1 / 19.2 * 18vw);
    background: url(../../assets/images/bluecircle.png) no-repeat center center;
  }
    .woman,.man{
      width: 30%;
      height: 38%;
      position: absolute;
      top: 40%;
      margin-top:-19%;
      background-size: contain;
      font-size: calc(1 / 10.8 * 18vh);
      color: #fff;
      text-align: center;
      box-sizing: border-box;
      padding-top: 8%;
      .num{
        position: absolute;
        bottom:calc(-1 / 10.8 * 30vh);
        width: 100%;
        text-align: center;
      }
    }
  .man_box{
    height: 100%;
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Echarts/SexChart.vue